module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width <= 1280
    }
  }, [(_vm.current !== 7) ? _c('div', {
    staticClass: "text-center pt-5",
    class: {
      mb110: _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(_vm.$vuetify.breakpoint.width > 1280 && _vm.current !== 1) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-back",
    attrs: {
      "id": "signup-back-button",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.handlePrevStage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/arrow_left.svg'),
      "width": "24",
      "alt": "arrow-left"
    }
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "150"
    }
  })]), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-close",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push("/")
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34"
  }, [_vm._v("close")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.current !== 7) ? _c('div', {
    staticClass: "onboarding auth",
    class: [
      ("onboarding-" + (_vm.currentStage.stage)),
      {
        allowFullPage: _vm.currentStage.allowFullPage,
        onMobile: _vm.onMobile,
        aboveMobile: !_vm.onMobile,
      } ]
  }, [(_vm.current <= 6 && _vm.$vuetify.breakpoint.width > 1280) ? _c('div', {
    staticClass: "auth__title"
  }, [_vm._v("\n        Sign up\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.currentStage.hideStage) ? _c('Stager', {
    attrs: {
      "staging": "onboarding"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.current === 1) ? _c('div', {
    staticClass: "stage-wrapper width-control"
  }, [_c('ChooseAccount')], 1) : (_vm.accountCategory === 'creator') ? _c('div', {
    staticClass: "stage-wrapper"
  }, [_c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 2) ? _c('AccountType', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 3) ? _c('AccountInfo', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 4) ? _c('ProfileImage', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 5) ? _c('AgeLocation', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 6) ? _c('GetVerified', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control _max"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 7) ? _c('CheckEmail', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 8) ? _c('AuthPlan') : _vm._e()], 1)], 1)]) : (_vm.accountCategory === 'listener') ? _c('div', {
    staticClass: "stage-wrapper"
  }, [_c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 2) ? _c('AccountType', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 3) ? _c('AccountInfo', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 4) ? _c('ProfileImage', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 5) ? _c('AgeLocation', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 6) ? _c('GetVerified', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 8) ? _c('ConfirmEmail') : _vm._e()], 1)], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.current === 7) ? _c('CheckEmail', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e544f3a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/index.vue
// module id = 1638
// module chunks = 180